export const srcSet="__VITE_ASSET__P28AoAzH__ 32w";export const width=32;export const height=32;export default{srcSet:srcSet,width:width,height:height};